import * as React from 'react'
import { AvailabilityCell } from './AvailabilityCell'

export const columns = [
  {
    accessorKey: 'Name',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.name,
  },
  {
    accessorKey: 'Status',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.status,
  },
  {
    accessorKey: 'Start Time',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.start_time,
  },
  {
    accessorKey: 'Duration',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.duration,
  },
  {
    accessorKey: 'Audience',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.audience,
  },
  {
    accessorKey: 'Availability',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <AvailabilityCell {...props} />,
  },
]

function TableHeader({ column }) {
  return <div className="font-roboto">{column.id}</div>
}
